export default __webpack_public_path__ + "static/media/ExportSpredsheet.27f4a40d.svg";